import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Historyitem } from '../../../models/historyitem';

@Component({
  selector: 'app-historyitem',
  templateUrl: './historyitem.component.html',
  styleUrls: ['./historyitem.component.scss']
})
export class HistoryitemComponent {

  @Input() historyitem?: Historyitem;
  constructor() { }
}
